export default "__VITE_ASSET__738d66a2__"